import { FC } from "react";
import { CooldownButton, CooldownButtonProps } from "./CooldownButton"

export type SpellButtonProps = {

} & Omit<CooldownButtonProps, 'width' | 'height'>;

export const SpellButton: FC<SpellButtonProps> = ({ ...rest }) => {
    return (<CooldownButton width={64} height={64} showLevels {...rest} effectedByOctarine fontSize={32} />);
}